import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FacetBlock({
  title,
  isOpenMobile,
  onToggleMobile,
  children,
  disabled = false,
}) {
  return (
    <div className="border border-gray-200 dark:border-zinc-700 overflow-hidden bg-white dark:bg-zinc-900">
      <button
        type="button"
        onClick={onToggleMobile}
        disabled={disabled}
        className="
          w-full px-3 py-3
          flex items-center justify-between
          bg-gray-50 dark:bg-zinc-800
          text-left
          disabled:opacity-60 disabled:cursor-not-allowed
          cursor-pointer
        "
      >
        <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">
          {title}
        </span>

        <span className="sm:hidden text-gray-500 dark:text-gray-300">
          {isOpenMobile ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
        </span>

        <span className="hidden sm:inline-block text-gray-500 dark:text-gray-300 opacity-60">
          <ChevronDown className="w-5 h-5" />
        </span>
      </button>

      <div className="">
        <div className="hidden sm:block">{children}</div>
        <div className={`${isOpenMobile ? "block" : "hidden"} sm:hidden`}>
          {children}
        </div>
      </div>
    </div>
  );
}
